export default __webpack_public_path__ + "static/media/z030mi0a.315c7986.mp3";